exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.active[data-v-611bac80] {\n    display: flex;\n}\n.hidden[data-v-611bac80] {\n    display: none;\n}\n.r-b-active[data-v-611bac80] {\n    display: unset;\n}\n.ui.fluid.dropdown[data-v-611bac80] {\n    width: 100% !important;\n}\n.red-border[data-v-611bac80] {\n    border: 1px solid red !important;\n}\n.restoredPassenger[data-v-611bac80] {\n    text-decoration: underline;\n    cursor: pointer;\n    font-style: italic;\n}\n\n", ""]);

// exports
